export enum Game {
  MK8 = 'mk8',
  MK8DX = 'mk8dx'
}